/**
 * Mastery Points icon — yellow disk with a darker amber graduation cap
 * stamped on top. Lifted from the Figma asset behind node 28301:118618
 * (data-name "circle-star" in Figma, though it's actually a tiny
 * cap-on-coin glyph). The original artboard was 60×60 with a 10-unit
 * drop shadow on every side; we crop to the inner 20×20 box around the
 * disc so the icon scales 1:1 against `h-5 w-5` / `h-7 w-7` callers.
 *
 * Colors are baked in (Figma deck-amber + Spaced-Repetition hard-300 +
 * amber-600 + #BB4D00 highlight) since the design is intentionally
 * multi-tone. `currentColor` is unused here.
 */

import type { SVGProps } from 'react';

export const MasteryPointsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="20 20 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}>
    <circle cx="30" cy="30" r="10" fill="#FBBF24" />
    <circle cx="30" cy="30" r="9.5" stroke="#FCD34D" />
    <path
      d="M25.1013 29.2986L29.7884 31.4463C29.8596 31.479 29.9374 31.4957 30.0157 31.4957C30.0939 31.4957 30.1714 31.479 30.2427 31.4463L34.938 29.305V29.2975L34.9305 29.2943L30.2427 27.1487C30.1714 27.1161 30.0939 27.0991 30.0157 27.0991C29.9374 27.0991 29.8599 27.1161 29.7887 27.1487L25.1011 29.2922L25.0939 29.2954L25.1013 29.2986Z"
      fill="#E17100"
    />
    <path
      d="M32.7503 31.5097L30.6956 32.4467C30.4821 32.5443 30.2502 32.5948 30.0157 32.5948C29.8101 32.5948 29.6065 32.5561 29.4156 32.4808L29.3347 32.4461L27.281 31.5051V32.5948C27.2811 32.7185 27.3923 32.9938 27.9399 33.2688C28.4619 33.5311 29.2084 33.6939 30.0157 33.6939C30.8229 33.6939 31.5695 33.5311 32.0915 33.2688C32.6389 32.9938 32.7503 32.7185 32.7503 32.5948V31.5097Z"
      fill="#BB4D00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.6956 32.4467L32.7503 31.5097L33.8442 31.0108L34.938 30.5123V32.5948C34.9381 32.8983 35.1829 33.1443 35.4849 33.1443C35.7869 33.1443 36.0318 32.8982 36.0319 32.5948V29.4368C36.0379 29.3883 36.0412 29.3393 36.0407 29.29C36.0385 29.075 35.9734 28.8654 35.8537 28.6871C35.7374 28.5137 35.5745 28.3774 35.384 28.294L30.6964 26.1487C30.4827 26.0507 30.2505 26 30.0157 26C29.7808 26 29.5486 26.0505 29.3349 26.1484L24.6479 28.2918C24.4563 28.3778 24.2933 28.5172 24.1784 28.6938C24.0621 28.8726 24 29.0818 24 29.2954C24 29.509 24.0621 29.718 24.1784 29.8967C24.2932 30.0731 24.4562 30.2127 24.6476 30.2987L26.1872 31.0039L27.281 31.5051L29.3347 32.4461L29.4156 32.4808C29.6065 32.5561 29.8101 32.5948 30.0157 32.5948C30.2502 32.5948 30.4821 32.5443 30.6956 32.4467ZM29.7884 31.4463L25.1013 29.2986L25.0939 29.2954L25.1011 29.2922L29.7887 27.1487C29.8599 27.1161 29.9374 27.0991 30.0157 27.0991C30.0939 27.0991 30.1714 27.1161 30.2427 27.1487L34.9305 29.2943L34.938 29.2975V29.305L30.2427 31.4463C30.1714 31.479 30.0939 31.4957 30.0157 31.4957C29.9374 31.4957 29.8596 31.479 29.7884 31.4463Z"
      fill="#E17100"
    />
    <path
      d="M27.281 32.5948V31.5051L26.1872 31.0039V32.5948C26.1872 33.3456 26.7674 33.9088 27.4506 34.252C28.1594 34.6081 29.0823 34.793 30.0157 34.793C30.9489 34.793 31.8717 34.6081 32.5805 34.252C33.2636 33.9088 33.8441 33.3456 33.8442 32.5948V31.0108L32.7503 31.5097V32.5948C32.7503 32.7185 32.6389 32.9938 32.0915 33.2688C31.5695 33.5311 30.8229 33.6939 30.0157 33.6939C29.2084 33.6939 28.4619 33.5311 27.9399 33.2688C27.3923 32.9938 27.2811 32.7185 27.281 32.5948Z"
      fill="#BB4D00"
    />
  </svg>
);
